import { string, object } from 'yup';

const initialFormSchema = object().shape({
  client: string().required('requiredField'),
});

export default initialFormSchema;
